import Styles from 'src/components/Styles';

export function getHeaderBackground(content: JSX.Element): JSX.Element {
  return content;
}

export function headerFontSize(): number {
  return Styles.Fonts.headerFont;
}

export function subHeaderFontSize(): number {
  return Styles.Fonts.sectionHeader;
}

export function headerContainerStyleDescriptor(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    safeArea: {
      backgroundColor: Styles.tabBarBackgroundColor,
    },
    container: {
      flex: 1,
      backgroundColor: Styles.tabBarBackgroundColor,
      flexDirection: 'column',
    },
    headerTextStyle: {
      textAlign: 'left',
      fontSize: headerFontSize(),
      color: Styles.Colors.PayNew.black01,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.latoRegular,
      height: 34,
      verticalAlign: 'middle',
    },
  };
}

export function subHeaderContainerStyleDescriptor(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    subHeaderTextStyle: {
      fontSize: subHeaderFontSize(),
      fontWeight: '700',
    },
  };
}

export function getBackIconColor(_transparent: boolean): string {
  return Styles.Colors.PayNew.black01;
}

export default {
  getHeaderBackground,
  headerContainerStyleDescriptor,
  getBackIconColor,
  headerFontSize,
  subHeaderFontSize,
  subHeaderContainerStyleDescriptor,
};
